import Biome from './Biome';

class River extends Biome {
  zIndex = -2;
}

export default River;
